import { setupDomain as setupDomainApi, getDomain as getDomainApi, validateDomain as validateDomainApi, IDnsEntriesResponse, IDnsVerificationResponse } from "../utils/fetch";
import IGlobalConfig from "../types/IGlobalConfig";

export class DomainService {
  static async setupDomain(
    config: IGlobalConfig,
    charityId: string,
    domain: string,
    serviceAccessToken: string
  ): Promise<IDnsEntriesResponse> {
    try {
      const response = await setupDomainApi(
        config?.adminServiceUrl,
        charityId,
        domain,
        serviceAccessToken
      );
      
      return response;
    } catch (error) {
      console.error("Failed to setup domain:", error);
      const errorMessage = error instanceof Error ? error.message : "Unknown error occurred";
      throw new Error(`Failed to setup domain: ${errorMessage}. Please check your domain and try again.`);
    }
  }

  static async getDomainData(
    config: IGlobalConfig,
    charityId: string,
    serviceAccessToken: string
  ): Promise<IDnsEntriesResponse> {
    try {
      const response = await getDomainApi(
        config?.adminServiceUrl,
        charityId,
        serviceAccessToken
      );
      
      return response;
    } catch (error) {
      console.error("Failed to fetch domain data:", error);
      const errorMessage = error instanceof Error ? error.message : "Unknown error occurred";
      throw new Error(`Failed to fetch DNS entries: ${errorMessage}`);
    }
  }

  static async validateDomainDns(
    config: IGlobalConfig,
    charityId: string,
    serviceAccessToken: string
  ): Promise<IDnsVerificationResponse> {
    try {
      const response = await validateDomainApi(
        config?.adminServiceUrl,
        charityId,
        serviceAccessToken
      );
      
      return response;
    } catch (error) {
      console.error("Failed to validate domain:", error);
      const errorMessage = error instanceof Error ? error.message : "Unknown error occurred";
      throw new Error(`DNS verification failed: ${errorMessage}. Please ensure your DNS records are correctly configured and try again.`);
    }
  }
}